import React from 'react'
import NavigationBar from '../General/NavigationBar'
import DropdownHeader from './DropdownHeader'
import TransactionDetails from './TransactionDetails'
import FloatingIcon from '../General/FloatingIcon'
import Navbar from './Navbar'

function Principal() {
  return (
    <div>
        <NavigationBar/>
        <DropdownHeader/>
        <TransactionDetails/>
        <FloatingIcon/>
        <Navbar/>
    </div>
  )
}

export default Principal